module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<div class="b-tour-component">\n	<div class="b-tour-component__image">\n		<img src="' + require("/app/node_modules/underscore-template-loader/file-loader.js?url=.%2Fimages%2Froute.svg!./images/route.svg") + '" alt="Перелет">\n	</div>\n	<div class="b-tour-component__text">\n		Перелет\n	</div>\n</div>';
}
return __p;
};
